<template>
  <div class="input-wr">
    <select ref="select">
      <option v-for="(item, i) in items" :key="i" :value="item.value">
        {{item.text}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    items: { type: Array, required: true }
  },
  data() {
    return { scrollbar: undefined };
  },
  watch: {
    value(value) {
      $(this.$refs.select)
        .val(value)
        .selectmenu("refresh");
    },
    items(value) {
      this.initSelectMenu(true);
    }
  },
  mounted() {
    this.initSelectMenu();
    $(this.$refs.select)
      .val(this.value)
      .selectmenu("refresh");
  },
  methods: {
    initSelectMenu(destroy) {
      if (this.scrollbar) this.scrollbar.destroy();
      this.scrollbar = undefined;
      if(destroy) $(this.$refs.select).selectmenu("destroy");
      const $menu = $(this.$refs.select).selectmenu({
        appendTo: $(this.$el),
        change: (event, data) => this.$emit("input", data.item.value),
        position: { my : "center top+10 ", at: "center bottom" },
        open: () => {
          var menu = "#" + $menu.attr("id") + "-menu";
          if (this.scrollbar) this.scrollbar.destroy();
          this.scrollbar = new PerfectScrollbar(menu, {
            wheelPropagation: false
          });
          $(menu).find('.ui-menu-item').css("width", "100%");
        },
        close: () => {
          var menu = "#" + $menu.attr("id") + "-menu";
          if (this.scrollbar) this.scrollbar.destroy();
          this.scrollbar = undefined;
          $(menu).find('.ui-menu-item').css("width", "");
        }
      });
    }
  },
  beforeDestroy() {
    if (this.scrollbar) this.scrollbar.destroy();
    $(this.$refs.select).selectmenu("destroy");
  }
};
</script>
